/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiChargingSessionsCompanyCodeGet$Json } from '../fn/charging-sessions/api-charging-sessions-company-code-get-json';
import { ApiChargingSessionsCompanyCodeGet$Json$Params } from '../fn/charging-sessions/api-charging-sessions-company-code-get-json';
import { apiChargingSessionsCompanyCodeGet$Plain } from '../fn/charging-sessions/api-charging-sessions-company-code-get-plain';
import { ApiChargingSessionsCompanyCodeGet$Plain$Params } from '../fn/charging-sessions/api-charging-sessions-company-code-get-plain';
import { apiChargingSessionsCompanyOverviewCompanyCodeGet$Json } from '../fn/charging-sessions/api-charging-sessions-company-overview-company-code-get-json';
import { ApiChargingSessionsCompanyOverviewCompanyCodeGet$Json$Params } from '../fn/charging-sessions/api-charging-sessions-company-overview-company-code-get-json';
import { apiChargingSessionsCompanyOverviewCompanyCodeGet$Plain } from '../fn/charging-sessions/api-charging-sessions-company-overview-company-code-get-plain';
import { ApiChargingSessionsCompanyOverviewCompanyCodeGet$Plain$Params } from '../fn/charging-sessions/api-charging-sessions-company-overview-company-code-get-plain';
import { apiChargingSessionsExportSessionsToCsvGet } from '../fn/charging-sessions/api-charging-sessions-export-sessions-to-csv-get';
import { ApiChargingSessionsExportSessionsToCsvGet$Params } from '../fn/charging-sessions/api-charging-sessions-export-sessions-to-csv-get';
import { apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json } from '../fn/charging-sessions/api-charging-sessions-parking-spots-parking-place-id-get-json';
import { ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Params } from '../fn/charging-sessions/api-charging-sessions-parking-spots-parking-place-id-get-json';
import { apiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain } from '../fn/charging-sessions/api-charging-sessions-parking-spots-parking-place-id-get-plain';
import { ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain$Params } from '../fn/charging-sessions/api-charging-sessions-parking-spots-parking-place-id-get-plain';
import { apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-consumer-user-id-get-json';
import { ApiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json$Params } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-consumer-user-id-get-json';
import { apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-consumer-user-id-get-plain';
import { ApiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain$Params } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-consumer-user-id-get-plain';
import { apiChargingSessionsStatisticCompanyCodeGet$Json } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-get-json';
import { ApiChargingSessionsStatisticCompanyCodeGet$Json$Params } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-get-json';
import { apiChargingSessionsStatisticCompanyCodeGet$Plain } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-get-plain';
import { ApiChargingSessionsStatisticCompanyCodeGet$Plain$Params } from '../fn/charging-sessions/api-charging-sessions-statistic-company-code-get-plain';
import { apiChargingSessionsStopChargingSessionPost } from '../fn/charging-sessions/api-charging-sessions-stop-charging-session-post';
import { ApiChargingSessionsStopChargingSessionPost$Params } from '../fn/charging-sessions/api-charging-sessions-stop-charging-session-post';
import { apiChargingSessionsStopChargingSessionSessionIdPost } from '../fn/charging-sessions/api-charging-sessions-stop-charging-session-session-id-post';
import { ApiChargingSessionsStopChargingSessionSessionIdPost$Params } from '../fn/charging-sessions/api-charging-sessions-stop-charging-session-session-id-post';
import { ChargingSessions } from '../models/charging-sessions';
import { CompanyOverviewResponse } from '../models/company-overview-response';
import { KwhStatisticResponse } from '../models/kwh-statistic-response';

@Injectable({ providedIn: 'root' })
export class ChargingSessionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiChargingSessionsCompanyOverviewCompanyCodeGet()` */
  static readonly ApiChargingSessionsCompanyOverviewCompanyCodeGetPath = '/api/ChargingSessions/companyOverview/{companyCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsCompanyOverviewCompanyCodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyOverviewCompanyCodeGet$Plain$Response(params: ApiChargingSessionsCompanyOverviewCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyOverviewResponse>> {
    return apiChargingSessionsCompanyOverviewCompanyCodeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsCompanyOverviewCompanyCodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyOverviewCompanyCodeGet$Plain(params: ApiChargingSessionsCompanyOverviewCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<CompanyOverviewResponse> {
    return this.apiChargingSessionsCompanyOverviewCompanyCodeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyOverviewResponse>): CompanyOverviewResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsCompanyOverviewCompanyCodeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyOverviewCompanyCodeGet$Json$Response(params: ApiChargingSessionsCompanyOverviewCompanyCodeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyOverviewResponse>> {
    return apiChargingSessionsCompanyOverviewCompanyCodeGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsCompanyOverviewCompanyCodeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyOverviewCompanyCodeGet$Json(params: ApiChargingSessionsCompanyOverviewCompanyCodeGet$Json$Params, context?: HttpContext): Observable<CompanyOverviewResponse> {
    return this.apiChargingSessionsCompanyOverviewCompanyCodeGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyOverviewResponse>): CompanyOverviewResponse => r.body)
    );
  }

  /** Path part for operation `apiChargingSessionsCompanyCodeGet()` */
  static readonly ApiChargingSessionsCompanyCodeGetPath = '/api/ChargingSessions/{companyCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsCompanyCodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyCodeGet$Plain$Response(params: ApiChargingSessionsCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingSessions>> {
    return apiChargingSessionsCompanyCodeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsCompanyCodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyCodeGet$Plain(params: ApiChargingSessionsCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<ChargingSessions> {
    return this.apiChargingSessionsCompanyCodeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingSessions>): ChargingSessions => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsCompanyCodeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyCodeGet$Json$Response(params: ApiChargingSessionsCompanyCodeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingSessions>> {
    return apiChargingSessionsCompanyCodeGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsCompanyCodeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsCompanyCodeGet$Json(params: ApiChargingSessionsCompanyCodeGet$Json$Params, context?: HttpContext): Observable<ChargingSessions> {
    return this.apiChargingSessionsCompanyCodeGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargingSessions>): ChargingSessions => r.body)
    );
  }

  /** Path part for operation `apiChargingSessionsStatisticCompanyCodeGet()` */
  static readonly ApiChargingSessionsStatisticCompanyCodeGetPath = '/api/ChargingSessions/statistic/{companyCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsStatisticCompanyCodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeGet$Plain$Response(params: ApiChargingSessionsStatisticCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<KwhStatisticResponse>> {
    return apiChargingSessionsStatisticCompanyCodeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsStatisticCompanyCodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeGet$Plain(params: ApiChargingSessionsStatisticCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<KwhStatisticResponse> {
    return this.apiChargingSessionsStatisticCompanyCodeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<KwhStatisticResponse>): KwhStatisticResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsStatisticCompanyCodeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeGet$Json$Response(params: ApiChargingSessionsStatisticCompanyCodeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<KwhStatisticResponse>> {
    return apiChargingSessionsStatisticCompanyCodeGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsStatisticCompanyCodeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeGet$Json(params: ApiChargingSessionsStatisticCompanyCodeGet$Json$Params, context?: HttpContext): Observable<KwhStatisticResponse> {
    return this.apiChargingSessionsStatisticCompanyCodeGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<KwhStatisticResponse>): KwhStatisticResponse => r.body)
    );
  }

  /** Path part for operation `apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet()` */
  static readonly ApiChargingSessionsStatisticCompanyCodeConsumerUserIdGetPath = '/api/ChargingSessions/statistic/{companyCode}/{consumerUserId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain$Response(params: ApiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<KwhStatisticResponse>> {
    return apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain(params: ApiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain$Params, context?: HttpContext): Observable<KwhStatisticResponse> {
    return this.apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<KwhStatisticResponse>): KwhStatisticResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json$Response(params: ApiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<KwhStatisticResponse>> {
    return apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json(params: ApiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json$Params, context?: HttpContext): Observable<KwhStatisticResponse> {
    return this.apiChargingSessionsStatisticCompanyCodeConsumerUserIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<KwhStatisticResponse>): KwhStatisticResponse => r.body)
    );
  }

  /** Path part for operation `apiChargingSessionsParkingSpotsParkingPlaceIdGet()` */
  static readonly ApiChargingSessionsParkingSpotsParkingPlaceIdGetPath = '/api/ChargingSessions/parkingSpots/{parkingPlaceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain$Response(params: ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargingSessions>>> {
    return apiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain(params: ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain$Params, context?: HttpContext): Observable<Array<ChargingSessions>> {
    return this.apiChargingSessionsParkingSpotsParkingPlaceIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChargingSessions>>): Array<ChargingSessions> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Response(params: ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargingSessions>>> {
    return apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json(params: ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Params, context?: HttpContext): Observable<Array<ChargingSessions>> {
    return this.apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChargingSessions>>): Array<ChargingSessions> => r.body)
    );
  }

  /** Path part for operation `apiChargingSessionsStopChargingSessionPost()` */
  static readonly ApiChargingSessionsStopChargingSessionPostPath = '/api/ChargingSessions/stopChargingSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsStopChargingSessionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingSessionsStopChargingSessionPost$Response(params?: ApiChargingSessionsStopChargingSessionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiChargingSessionsStopChargingSessionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsStopChargingSessionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiChargingSessionsStopChargingSessionPost(params?: ApiChargingSessionsStopChargingSessionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiChargingSessionsStopChargingSessionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiChargingSessionsStopChargingSessionSessionIdPost()` */
  static readonly ApiChargingSessionsStopChargingSessionSessionIdPostPath = '/api/ChargingSessions/stopChargingSession/{sessionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsStopChargingSessionSessionIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStopChargingSessionSessionIdPost$Response(params: ApiChargingSessionsStopChargingSessionSessionIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiChargingSessionsStopChargingSessionSessionIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsStopChargingSessionSessionIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsStopChargingSessionSessionIdPost(params: ApiChargingSessionsStopChargingSessionSessionIdPost$Params, context?: HttpContext): Observable<void> {
    return this.apiChargingSessionsStopChargingSessionSessionIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiChargingSessionsExportSessionsToCsvGet()` */
  static readonly ApiChargingSessionsExportSessionsToCsvGetPath = '/api/ChargingSessions/exportSessionsToCsv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiChargingSessionsExportSessionsToCsvGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsExportSessionsToCsvGet$Response(params?: ApiChargingSessionsExportSessionsToCsvGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiChargingSessionsExportSessionsToCsvGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiChargingSessionsExportSessionsToCsvGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiChargingSessionsExportSessionsToCsvGet(params?: ApiChargingSessionsExportSessionsToCsvGet$Params, context?: HttpContext): Observable<void> {
    return this.apiChargingSessionsExportSessionsToCsvGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
